import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Navigate, Outlet } from 'react-router-dom';

import useLocalStorage from '~hooks/useLocalStorage';
import { ROUTES } from '~routes/routesDictionary';

const Unauthenticated = () => {
  const { userData, recaptcha, setRecaptcha } = useLocalStorage();

  return (
    <>
      {Object.keys(userData).length > 2 ? (
        <Navigate to={ROUTES.PLATFORM} />
      ) : (
        <>
          <GoogleReCaptcha
            onVerify={(token) => {
              if (!recaptcha) setRecaptcha(token);
            }}
          />
          <Outlet />
        </>
      )}
    </>
  );
};

export default Unauthenticated;
